import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Lookup } from "../../models/Lookup";
import { SearchTerm } from "../../models/search/SearchTerm";
import { TableColumn } from "../../models/table/TableColumn";
import TableTab from "../tabs/table-tab";
import {ASSIGNMENT_LIMITS} from "@/constants/system-constants.ts";
import {toast} from "react-toastify";

interface AssignStepProps {
    onNext: (e: any) => void;
    setTotalSelected: React.Dispatch<React.SetStateAction<number>>;
    tableColumns: TableColumn[];
    searchColumns: SearchTerm[];
    dataMethod: (listParameter?: any) => Promise<any>;
    title: string;
    lookup?: Lookup[];
    selectedIds: string[];
    selectedRows: any[];
    setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
    setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
    originalSelectedIds: string[];
    alwaysSelectedAndDisabled?: string[]
}

const AssignStep: FC<AssignStepProps> = ({ tableColumns, searchColumns, onNext, setTotalSelected, dataMethod, title, selectedIds, selectedRows,setSelectedIds,setSelectedRows,lookup, originalSelectedIds, alwaysSelectedAndDisabled }) => {
    const { setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();

    const getTotalSelected = (newSelectedIds: string[]): number => {
        const toBeUnassigned = originalSelectedIds.filter((id) => !newSelectedIds.includes(id));
        const toBeAssigned = newSelectedIds.filter((id) => !originalSelectedIds.includes(id));
        return toBeAssigned.length + toBeUnassigned.length;
    }

    // This method is here to make sure that there cannot be more than a 100 records selected between the assigned and unassigned
    // as this can cause issues between Primo and the database connection.
    // TODO: This is a temp fix as we need to try and batch these items instead.
    const updateSelectedIds = (newSelectedIds: string[]) => {
        if (getTotalSelected(newSelectedIds) > ASSIGNMENT_LIMITS.MAX_ASSIGNMENTS_PER_USER) {
            toast.error(translate.byKey(TranslationKeys.aMaximumOf100RecordsCanBeSelected));
            return;
        }
        setSelectedIds(newSelectedIds);
        setTotalSelected(getTotalSelected(newSelectedIds));
    }

    return <div className="pt-3 pr-3 h-full relative">
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                dataMethod={dataMethod}
                tableDescriptor={tableColumns}
                searchDescriptor={searchColumns}
                useTable
                usePagination
                useFilter
                useSearch
                useSort
                lookup={lookup} 
                alwaysSelectedAndDisabled={alwaysSelectedAndDisabled}>
                <TableTab
                    cyName="assignStep_tbl"
                    title={title}
                    selectRows={true}
                    selectedIds={selectedIds}
                    selectedRows={selectedRows}
                    setSelectedIds={(selectedIds) => {updateSelectedIds(selectedIds)}}
                    setSelectedRows={setSelectedRows}/>
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${getTotalSelected(selectedIds) > 0 ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    data-cy="nextButton"
                    onClick={(e) => {
                        if (getTotalSelected(selectedIds) > 0) {
                            onNext(e);
                            setFieldValue("selectedIds", selectedIds);
                            setFieldValue("selectedRows", selectedRows);
                        }
                    }}>
                    {translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>
}

export default AssignStep;